"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLoginAttemptsLimitExceeded = exports.removeExpiredLoginAttempts = exports.registerLoginAttempt = exports.removeLoginAttempts = exports.setLoginAttempt = exports.getLoginAttempts = void 0;
const redirect_1 = require("../../build-babel/redirect");
const localhost_1 = require("../../build-babel/redirect/localhost");
const LOGIN_ATTEMPTS_KEY = 'AUTH_LOGIN_ATTEMPTS';
const LOGIN_ATTEMPT_EXPIRATION_PERIOD_IN_MS = 10 * 1000; // 10 seconds
const LOGIN_ATTEMPTS_LIMIT = 3;
const LOGIN_LOCALHOST_ATTEMPTS_LIMIT = 4;
const getLoginAttempts = () => {
  const loginAttempts = sessionStorage.getItem(LOGIN_ATTEMPTS_KEY);
  return loginAttempts ? JSON.parse(loginAttempts) : [];
};
exports.getLoginAttempts = getLoginAttempts;
const setLoginAttempt = loginAttempt => {
  const loginAttempts = (0, exports.getLoginAttempts)();
  loginAttempts.push(loginAttempt);
  sessionStorage.setItem(LOGIN_ATTEMPTS_KEY, JSON.stringify(loginAttempts));
};
exports.setLoginAttempt = setLoginAttempt;
const removeLoginAttempts = () => {
  sessionStorage.removeItem(LOGIN_ATTEMPTS_KEY);
};
exports.removeLoginAttempts = removeLoginAttempts;
const registerLoginAttempt = () => {
  (0, exports.removeExpiredLoginAttempts)();
  const newLoginAttempt = {
    datetime: Date.now()
  };
  (0, exports.setLoginAttempt)(newLoginAttempt);
};
exports.registerLoginAttempt = registerLoginAttempt;
const removeExpiredLoginAttempts = () => {
  const loginAttempts = JSON.parse(JSON.stringify((0, exports.getLoginAttempts)()));
  if (loginAttempts.length > 0) {
    (0, exports.removeLoginAttempts)();
    loginAttempts.filter(loginAttempt => Date.now() - loginAttempt.datetime < LOGIN_ATTEMPT_EXPIRATION_PERIOD_IN_MS).forEach(actualLoginAttempt => (0, exports.setLoginAttempt)(actualLoginAttempt));
  }
};
exports.removeExpiredLoginAttempts = removeExpiredLoginAttempts;
const isLocalhostAttempt = () => {
  const redirectUrl = (0, redirect_1.getRedirectUrl)();
  return redirectUrl === null ? false : (0, localhost_1.isLocalhostRedirect)(redirectUrl);
};
const isLoginAttemptsLimitExceeded = () => {
  return isLocalhostAttempt() ? (0, exports.getLoginAttempts)().length >= LOGIN_LOCALHOST_ATTEMPTS_LIMIT : (0, exports.getLoginAttempts)().length >= LOGIN_ATTEMPTS_LIMIT;
};
exports.isLoginAttemptsLimitExceeded = isLoginAttemptsLimitExceeded;
//# sourceMappingURL=loginAttempts.js.map